export default "__VITE_ASSET__7a7fb1ac__"